import { JwtAxios } from '@/packaging';

export const domeggookApi = {
  // POST /api/Template/Market/SetDomeggookApi
  // payload: { marketAccount(회원ID), key1(API키 aid), key2(비밀번호) }
  async SetDomeggookApi(body) {
    const responseModel = await JwtAxios.post('/Template/Market/SetDomeggookApi', body);
    return responseModel;
  },
  async GetDomeggookApiTemplate(marketAccount) {
    const responseModel = await JwtAxios.get(
      `/Template/Market/GetDomeggookApiTemplate?marketAccount=${marketAccount}`
    );
    return responseModel;
  },
  async SetDomeggookApiTemplate(model) {
    const responseModel = await JwtAxios.post(`/Template/Market/SetDomeggookApiTemplate`, model);
    return responseModel;
  },
  // 판매자센터에 등록된 출고/반품지 목록
  async GetDomeggookLocations(marketAccount) {
    const responseModel = await JwtAxios.get(
      `/Template/Market/GetDomeggookLocations?marketAccount=${marketAccount}`
    );
    return responseModel;
  }
};
